module.exports = __webpack_public_path__ + "img/medium.f2e30597.png";